export default function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/is-number.js